import { getCloudinaryImageSources } from '../../../utils/cloudinary';

export const getImageSources = (relativeSrc, imageDomain, focalPoint) => {
  return [
    ...getCloudinaryImageSources(
      imageDomain,
      {
        relativeSrc,
        width: 364,
        height: 245,
        focalPoint,
      },
      '(min-width: 975px)',
    ),
    ...getCloudinaryImageSources(
      imageDomain,
      {
        relativeSrc,
        width: 287,
        height: 287,
        focalPoint,
      },
      '(min-width: 768px) and (max-width: 974px)',
    ),
    ...getCloudinaryImageSources(
      imageDomain,
      { relativeSrc, width: 747, height: 200, focalPoint },
      '(min-width: 480px) and (max-width: 767px)',
    ),
    ...getCloudinaryImageSources(
      imageDomain,
      { relativeSrc, width: 459, height: 200, focalPoint },
      '(min-width: 376px) and (max-width: 479px)',
    ),
    ...getCloudinaryImageSources(
      imageDomain,
      { relativeSrc, width: 355, height: 200, focalPoint },
      '(max-width: 375px)',
    ),
  ];
};
